import React from 'react';
import { ArrowRightIcon, CheckCircleIcon, HandshakeIcon } from 'lucide-react';
export const DealHelp = () => {
  return <section id="dealflow" className="bg-[#f2efeb] py-14 md:py-20 border-t border-[#d9d3cb]" data-id="element-53">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-54">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-55">
          <div className="order-2 lg:order-1" data-id="element-56">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 font-serif-display text-[#2b2826]" data-id="element-57">
              Need Help With <span className="text-[#c9a875]" data-id="element-58">A Deal?</span>
            </h2>
            <p className="text-lg sm:text-xl text-[#2b2826]/80 mb-8 max-w-2xl" data-id="element-59">
              We have a network of active cash buyers and investors ready to
              purchase your deals. Partner with us and tap into our extensive
              resources to close more transactions.
            </p>

            <div className="space-y-6 mb-10" data-id="element-60">
              <div className="flex items-start" data-id="element-61">
                <span className="text-[#c9a875] mr-4 font-serif-display text-2xl leading-none mt-1" data-id="element-62">
                  1.
                </span>
                <div data-id="element-63">
                  <h4 className="text-[#292f33] font-medium text-lg mb-1" data-id="element-64">
                    Access Our Buyer Network
                  </h4>
                  <p className="text-[#292f33]/70 text-sm sm:text-base font-light" data-id="element-65">
                    Connect with our extensive database of verified cash buyers
                    and investors across the country.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-66">
                <span className="text-[#c9a875] mr-4 font-serif-display text-2xl leading-none mt-1" data-id="element-67">
                  2.
                </span>
                <div data-id="element-68">
                  <h4 className="text-[#292f33] font-medium text-lg mb-1" data-id="element-69">
                    Co-Wholesaling Partnership
                  </h4>
                  <p className="text-[#292f33]/70 text-sm sm:text-base font-light" data-id="element-70">
                    Split profits with us on deals you're struggling to move
                    quickly. We'll bring the buyers, you bring the deals.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-71">
                <span className="text-[#c9a875] mr-4 font-serif-display text-2xl leading-none mt-1" data-id="element-72">
                  3.
                </span>
                <div data-id="element-73">
                  <h4 className="text-[#292f33] font-medium text-lg mb-1" data-id="element-74">
                    Marketing Support
                  </h4>
                  <p className="text-[#292f33]/70 text-sm sm:text-base font-light" data-id="element-75">
                    Let our team help market your property to the right buyers
                    with professional materials and targeted outreach.
                  </p>
                </div>
              </div>
            </div>

            <a href="#funding-form" className="inline-flex items-center gap-2 sm:gap-2.5 bg-[#c9a875] text-white font-medium py-3 px-6 sm:py-4 sm:px-8 rounded-full hover:bg-[#b08e5c] transition-all text-sm sm:text-base" data-id="element-76">
              Partner With Us
              <ArrowRightIcon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-77" />
            </a>
          </div>

          <div className="order-1 lg:order-2 relative" data-id="element-78">
            <div className="bg-[#2b2826] rounded-2xl border border-[#403a35] p-8 sm:p-10" data-id="element-79">
              <div className="flex items-center gap-4 mb-8" data-id="element-80">
                <div className="w-16 h-16 rounded-full bg-[#c9a875]/10 flex items-center justify-center" data-id="element-81">
                  <HandshakeIcon className="w-8 h-8 text-[#c9a875]" data-id="element-82" />
                </div>
                <div data-id="element-83">
                  <h3 className="text-2xl font-bold text-[#f2efeb]" data-id="element-84">
                    JV Program
                  </h3>
                  <p className="text-[#c9a875]" data-id="element-85">50/50 Profit Split</p>
                </div>
              </div>

              <ul className="space-y-4 mb-8" data-id="element-86">
                <li className="flex items-center gap-3 text-[#f2efeb]/80" data-id="element-87">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#c9a875]" data-id="element-88" />
                  We provide 100% of the funding
                </li>
                <li className="flex items-center gap-3 text-[#f2efeb]/80" data-id="element-89">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#c9a875]" data-id="element-90" />
                  We handle all paperwork & title
                </li>
                <li className="flex items-center gap-3 text-[#f2efeb]/80" data-id="element-91">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#c9a875]" data-id="element-92" />
                  You bring the deal
                </li>
                <li className="flex items-center gap-3 text-[#f2efeb]/80" data-id="element-93">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#c9a875]" data-id="element-94" />
                  We split the assignment fee
                </li>
              </ul>

              <div className="bg-[#1c1916] rounded-xl p-6 border border-[#403a35]" data-id="element-95">
                <p className="text-sm text-[#f2efeb]/60 mb-2" data-id="element-96">Example Deal</p>
                <div className="flex justify-between items-end" data-id="element-97">
                  <div data-id="element-98">
                    <p className="text-2xl font-bold text-[#f2efeb]" data-id="element-99">$20,000</p>
                    <p className="text-sm text-[#c9a875]" data-id="element-100">Total Assignment</p>
                  </div>
                  <div className="text-right" data-id="element-101">
                    <p className="text-2xl font-bold text-[#f2efeb]" data-id="element-102">$10,000</p>
                    <p className="text-sm text-[#c9a875]" data-id="element-103">Your Share</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#c9a875]/10 rounded-full blur-2xl -z-10" data-id="element-104" />
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-[#c9a875]/10 rounded-full blur-2xl -z-10" data-id="element-105" />
          </div>
        </div>
      </div>
    </section>;
};